import { Api } from '@/src/store/api'

export const CardApplicationApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /card/onboarding/applications': {
      invalidatesTags: ['GET /card/onboarding/applications'],
    },
    'POST /card/onboarding/applications/:applicationId/submit': {
      invalidatesTags: ['GET /card/onboarding/applications'],
    },
    'POST /card/onboarding/applications/:applicationId/terms/acknowledge': {
      invalidatesTags: ['GET /card/onboarding/applications', 'GET /card/accounts'],
    },
    'POST /card/onboarding/applications/:applicationId/document-upload-url': {
      invalidatesTags: ['GET /card/onboarding/applications'],
    },
  },
})
